import { render, staticRenderFns } from "./detail-solde-de-recuperation-a-venir-list.vue?vue&type=template&id=2bbc71b4&scoped=true"
import script from "./detail-solde-de-recuperation-a-venir-list.vue?vue&type=script&lang=js"
export * from "./detail-solde-de-recuperation-a-venir-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbc71b4",
  null
  
)

export default component.exports